'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SearchResultRecord from 'SalesContentIndexUI/data/records/SearchResultRecord';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FolderNavFooter = ({
  selectedFolder,
  onConfirm,
  onClose
}) => /*#__PURE__*/_jsxs(TFlex, {
  children: [/*#__PURE__*/_jsx(Button, {
    use: "primary",
    onClick: onConfirm,
    disabled: selectedFolder === null,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.tableRowHoverButtons.move"
    })
  }), /*#__PURE__*/_jsx(Button, {
    use: "secondary",
    onClick: onClose,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.tableRowHoverButtons.cancel"
    })
  })]
});
FolderNavFooter.propTypes = {
  selectedFolder: PropTypes.instanceOf(SearchResultRecord),
  onConfirm: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};
export default FolderNavFooter;